import { render, staticRenderFns } from "./VehicleMonthlyAverageMileageChart.vue?vue&type=template&id=5072a971&scoped=true"
import script from "./VehicleMonthlyAverageMileageChart.vue?vue&type=script&lang=ts"
export * from "./VehicleMonthlyAverageMileageChart.vue?vue&type=script&lang=ts"
import style0 from "./VehicleMonthlyAverageMileageChart.vue?vue&type=style&index=0&id=5072a971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5072a971",
  null
  
)

export default component.exports